import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
import { API_URL } from '../utils/constants';

export const getFloorplanDownloadUrl = async (projectId, floorplanId) => {
  const apiPath = `projects/${projectId}/floorplans/${floorplanId}/signed-url`;

  const request = {
    url: `${API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data.url;
};
